var _rect, _rect2, _rect3, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 18",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chile flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 9,
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 9,
    width: 24,
    height: 9,
    fill: "#D52B1E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 9,
    fill: "#0039A6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "4,2.1 4.6,3.8 6.4,3.8 5,4.9 5.5,6.7 4,5.6 2.5,6.7 3,4.9 1.6,3.8 3.4,3.8",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCl);
export default __webpack_public_path__ + "static/media/cl.7636abbd0c1c648b8a057777f94524d1.svg";
export { ForwardRef as ReactComponent };